import React from 'react';

import { isEmptyCollection, useTournamentState } from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

import useIsSwipeGrid from 'common/Widgets/Tournament/useIsSwipeGrid';
import EventLoader from 'components/Pages/EventLoader';
import EventSwipeGridLoader from 'components/Pages/EventSwipeGridLoader';

const TournamentLoader = ({ children }) => {
  const { events, initialized, loading } = useTournamentState();

  const isSwipeGrid = useIsSwipeGrid();

  if (!initialized && loading) {
    return (
      <div className="tournament-table-body-container">
        {isSwipeGrid ? <EventSwipeGridLoader /> : <EventLoader />}
      </div>
    );
  }

  if (isEmptyCollection(events)) {
    return (
      <EmptyStateView
        description="tournament_events_empty_message"
        title="tournament_events_empty"
      />
    );
  }

  return children;
};

export default TournamentLoader;
